<template>
  <div>
    <!-- Siderbar for Filters Advance -->
    <sidebar-filters
      :filter="filter"
      @reload="sideBarSearch"
      @resetAllFilters="resetFiltersButtons"
    ></sidebar-filters>

    <b-row class="d-flex align-items-center px-1 mt-2">
      <b-col cols="12">
        <slot name="buttons"></slot>
      </b-col>
      <b-col v-if="showPaginator" cols="12">
        <slot name="paginator">
          <b-row>
            <!-- Info Paginator -->

            <b-col
              sm="12"
              md="6"
              class="d-flex align-items-center justify-content-center justify-content-md-start"
            >
              <span
                class="text-muted"
                v-t="{
                  path: 'ShowingAll',
                  locate: $i18n.locale,
                  args: {
                    from: paginate.from,
                    to: paginate.to,
                    of: paginate.of,
                  },
                }"
              >
              </span>
            </b-col>

            <!-- Pagination -->
            <b-col
              sm="12"
              md="6"
              class="d-flex align-items-center justify-content-center justify-content-md-end"
            >
              <slot name="pagination">
                <b-pagination
                  v-model="paginate.currentPage"
                  :total-rows="paginate.of"
                  :per-page="paginate.perPage"
                  first-number
                  last-number
                  class="mt-1 mt-md-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @input="$emit('onChangeCurrentPage', $event)"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </slot>
            </b-col>
          </b-row>
        </slot>
      </b-col>

      <b-col cols="12">
        <b-row>
          <b-col
            v-if="showPaginator"
            sm="12"
            md="6"
            :lg="noVisiblePrincipalFilter ? '6' : '3'"
            class="d-flex align-items-center justify-content-center justify-content-md-start mb-1 mb-md-0"
          >
            <label v-t="'SHOW'"></label>
            <v-select
              v-model="paginate.perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="paginate.perPageOptions"
              :clearable="false"
              style="min-width: 100px"
              size="sm"
              class="per-page-selector d-inline-block mx-50"
              @input="$emit('reload', false)"
            />
            <label class="mr-2" v-t="'ENTRIES'"></label>
            <feather-icon
              class="cursor-pointer"
              icon="RefreshCcwIcon"
              size="20"
              @click="resetFilter"
            />

            <slot name="special-button"> </slot>
          </b-col>

          <b-col
            v-else
            :md="noVisiblePrincipalFilter ? '6' : '3'"
            sm="12"
            class="d-flex align-items-center justify-content-center justify-content-md-start mb-1 mb-md-0"
          >
            <feather-icon
              class="cursor-pointer"
              icon="RefreshCcwIcon"
              size="20"
              @click="resetFilter"
            />
            <slot name="special-button"> </slot>
          </b-col>

          <b-col sm="12" md="6" lg="5" class="">
            <div
              class="d-flex align-items-center justify-content-center justify-content-md-end"
            >
              <slot name="buttons-paginator" />
            </div>
          </b-col>

          <!-- Search -->
          <b-col md="12" lg="4">
            <div
              class="d-flex align-items-center justify-content-end align-items-center mt-1 mt-lg-0"
            >
              <slot name="buttons-filter" />
              <b-input-group v-if="!noVisiblePrincipalFilter" class="mr-1">
                <b-form-input
                  v-if="filterPrincipal.type === 'input'"
                  v-model="filterPrincipal.model"
                  :type="filterPrincipal.inputType"
                  :placeholder="$t(filterPrincipal.placeholder)"
                  :class="filterPrincipal.class"
                  @keyup.enter="$emit('reload')"
                />
                <b-input-group-append>
                  <b-button variant="primary" @click="$emit('reload')">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-button
                v-if="hasFilters"
                v-b-toggle.sidebar-right
                v-b-tooltip.hover.right="$t('advanced search')"
                variant="primary"
              >
                <div class="d-flex justify-content-between">
                  <feather-icon icon="FilterIcon" size="15" />
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12">
        <div class="table-responsive mt-1">
          <slot name="table" />
        </div>
      </b-col>

      <!-- <b-col cols="12">
        <b-table-simple responsive>
          <b-thead>
            <b-tr>
              <b-th v-for="header in headers" :key="header.name" scope="col">
                <b>{{ $t(header.name) }}</b>
              </b-th>

              <b-th v-for="day in days" :key="day.prefix" scope="col">
                <b>{{ $t(day.prefix) }} {{ day.date }}</b>
              </b-th>
            </b-tr>
          </b-thead>

          <tbody style="font-size: 5rem !important" v-if="data.length > 0">
            <slot name="tbody"></slot>
          </tbody>

          <tbody v-else>
            <slot name="no-data">
              <b-tr>
                <b-td colspan="8" class="text-center">
                  <img
                    class="my-5"
                    :src="require('@/assets/images/tables/empty_data.png')"
                    alt="empty"
                    border="0"
                    width="200"
                  />
                  <h5 class="text-muted mb-5" v-t="'No data available'"></h5>
                </b-td>
              </b-tr>
            </slot>
          </tbody>
        </b-table-simple>
      </b-col> -->
    </b-row>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import SidebarFilters from "@/views/commons/filter-slot/SidebarFilters.vue";

export default {
  props: {
    showPaginator: {
      type: Boolean,
      default: true,
    },
    noVisiblePrincipalFilter: {
      required: false,
      default: false,
    },
    filterPrincipal: {
      required: false,
      type: Object,
    },
    days: {
      type: Array,
      default: () => [
        {
          prefix: "Mon",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Tue",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Wed",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Thu",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Fri",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Sat",
          date: moment().format("YYYY-MM-DD"),
        },
        {
          prefix: "Sun",
          date: moment().format("YYYY-MM-DD"),
        },
      ],
    },
    headers: {
      type: Array,
      default: () => [
        {
          name: "User",
        },
      ],
    },
    paginate: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SidebarFilters,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
    };
  },
  mounted() {
    this.paginate.perPage = parseInt(this.perPage);
    if (this.paginate.perPageOptions == null) {
      this.paginate.perPageOptions = [10, 25, 50, 100];
    }
  },
  created() {},
  methods: {
    sideBarSearch() {
      this.filterPrincipal.model = "";
      this.$emit("reload");
    },
    resetFiltersButtons() {
      if (this.filter) {
        this.filter.map((fil) => {
          fil.model = null;
        });
      }
      this.$emit("reset-all-filters");
    },
    changePage(page) {
      this.currentPage = page;
      this.$emit("changePage", page);
    },
    resetFilter() {
      if (this.filter) {
        this.filter.map((fil) => {
          fil.model = null;
        });
      }
      this.filterPrincipal.model = "";
      this.$emit("reload");
    },
  },
  beforeDestroy() {},
  watch: {},
  computed: {
    hasFilters() {
      return this.filter ? Object.keys(this.filter).length !== 0 : false;
    },
    ...mapGetters({
      perPage: "appConfig/perPage",
    }),
  },
};
</script>
<style scoped>
</style>